import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert } from "reactstrap";
import { post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import UploadImage from "common/uploadImage";
import { ADD_STATUS, LANGUAGES_SEARCH } from "helpers/api_endpoints";
import Select from "react-select";


//meta title
document.title = "Add Status";

const AddStatus = () => {

    const [status, setStatus] = useState(0);
    const [name, setName] = useState('');
    const [notify, setNotify] = useState(1);
    const [errorMsg, seterrorMsg] = useState('');
    const [valued, setValued] = useState({"title":[]});
    const [languages, setLanguages] = useState([]);
    const navigate = useNavigate();

    const handleSubmit = () => {
        // const imagePath = document.getElementById('imagePath').value;
        const config = { name, status, notify };
        post(ADD_STATUS, config)
            .then(response => {
                if (response.code == 201) {
                    navigate('/status', { state: { successMsg: 'Added SuccessFully' } });
                }
            })
            .catch(error => {
                seterrorMsg('Creation Failed');
            })
    }

    useEffect(() => {
        post(`${LANGUAGES_SEARCH}`,{status:1})
            .then(response => {
                setLanguages(response.data);
                // setLoading(false);
            })
            .catch(error => {
                console.log(error)
            })
    }, []);

    const handleToggleCheckBoxStatus = () => {
        if (status) {
            setStatus(0);
        }
        else {
            setStatus(1)
        }
    }
    const handleName = (languageId,value) => {
        const ln = valued.title.filter(el =>{
            return Object.keys(el)[0] == languageId;
        })
        
        if(ln==undefined || ln.length <1)
        {
            const ob = {};
            ob[languageId] = value;
            valued.title.push(ob);
        }
        else
        {
            ln[0][languageId] = value;
        }
        setName(JSON.stringify(valued));             
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="status" breadcrumbItem="Add Status" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                                            {
                                                languages.map((language, index) => (
                                                    <Row key={index}>
                                                    <div className="form-group col-md-4 mt-2">
                                                        <Label className="form-label"><Trans>Name ({language.name})</Trans></Label>
                                                        <Input
                                                            name="name"
                                                            // value={name}
                                                            className="form-control"
                                                            placeholder="Enter  Name"
                                                            type="text"
                                                            onChange={(e) => handleName(language.id,e.target.value)}
                                                            required={language.id==1||language.id==2?true:false} ></Input>
                                                    </div>
                                                </Row>
                                                ))
                                            }

                                            <div className="form-group col-md-2 mt-2">
                                                <Label className="form-label"><Trans>Status</Trans></Label>
                                                <div className="form-check form-check-end">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value={1}
                                                        id="defaultCheck2"
                                                        checked={status}
                                                        onClick={handleToggleCheckBoxStatus}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="defaultCheck2"
                                                    >
                                                        <Trans>Active</Trans>
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="form-group col-md-2 mt-2">
                                                <Label className="form-label"><Trans>Notify</Trans></Label>
                                                <Input
                                                    name="notify"
                                                    className="form-control"
                                                    placeholder=""
                                                    type="number"
                                                    onChange={(e) => setNotify(e.target.value)}
                                                    required 
                                                    ></Input>
                                            </div>

                                        </Row>
                                        <div className="mt-4">
                                            <Button type="submit" color="danger">
                                                <Trans>Submit</Trans>
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddStatus
